export default __webpack_public_path__ + "static/media/bp_plus.58516145.svg";